export type AlertType = 1 | 2 | 3;

export enum AlertTypeDescription {
  OMIP = 'OMIP',
  OMIE = 'OMIE',
  CONSUMO = 'CONSUMO',
}
